<template>
  <div class="allprice">
    <div class="p-name">{{ allname }}</div>
    <div class="p-container">
      <div class="c-img">
        <!-- <img :src="img" alt="" style="width:150px;"> -->
        <el-image
          style="width: 110px; height: 110px"
          :src="img"
          :preview-src-list="imgarr"
        >
        </el-image>
      </div>
      <div class="c-info">
        <div class="top">
          <div class="t-el">
            <span class="t-label">品名：</span>
            {{ dusname }}
          </div>
          <div class="t-el">
            <span class="price">
              <span class="price-unit">¥</span>
              {{ price == "NaN" ? "未定价" : price }}
            </span>
            <span class="version" v-if="sumprice != 'NaN'"
              >({{ content.time }})</span
            >
          </div>
        </div>
        <div class="bottom">
          <div class="dis">
            <div class="center">
              <span>本体：</span>
              <el-input-number
                controls-position="right"
                :precision="2"
                :step="1"
                v-model="spenum"
                :min="1"
                :max="100"
                size="mini"
                class="disnum"
                @change="hspe"
              ></el-input-number>
            </div>
            <div class="center">
              <span>附件：</span>
              <el-input-number
                controls-position="right"
                :precision="2"
                :step="1"
                v-model="accnum"
                :min="1"
                :max="100"
                size="mini"
                class="disnum"
                @change="hacc"
              ></el-input-number>
            </div>
          </div>
          <div class="copy">
            <button @click="copy" id="charu">插入</button>
            <el-input-number
              controls-position="right"
              v-model="num"
              :min="1"
              :max="9999"
              size="mini"
            ></el-input-number>
            <div class="c-none">
              <el-input
                type="textarea"
                :autosize="{ minRows: 1, maxRows: 1.1 }"
                v-model="textdata"
                id="copydata"
              ></el-input>
              <button id="deletedata" class="del" @click="copydel">清空</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      img: "",
      imgarr: [],
      spenum: 100 /* 本体折扣 */,
      accnum: 100 /* 附件折扣 */,
      num: 1 /* 插入数据 */,
      textdata: "" /* 文本域内容 */,
    };
  },
  computed: {
    ...mapState(["dusname", "fname", "sid", "price", "s","fsortname"]),
    sumprice() {
      return this.$store.state.sumprice;
    },
    allname() {
      return this.$store.state.allname;
    },
    content() {
      return this.$store.state.content;
    },
  },

  watch: {
    sid(newVal) {
      this.imgsrc(newVal);
      this.delnum();
    },
  },

  created() {
    this.imgsrc(this.sid);
  },

  methods: {
    imgsrc(id) {
      this.img = "http://dqb-1688.com/image/" + id + ".jpg";
      this.imgarr = ["http://dqb-1688.com/image/" + id + ".jpg"];
    },
    /* 本体折扣 */
    hspe(n) {
      this.$store.commit("spedisnum", n);
    },
    /* 附件折扣 */
    hacc(m) {
      this.$store.commit("accdisnum", m);
    },

    /* 插入数据 */
    copy() {
      // console.log(this.s);
      let a = 0,
        b = 0,
        c = "";
      for (let i = 0; i < this.content.inventory.length; i++) {
        if (this.content.inventory[i].main) {
          a = this.content.inventory[i].price;
          c +=
            this.fsortname +
            "," +
            this.s +
            "," +
            this.content.inventory[i].name +
            "," +
            this.num +
            "," +
            this.content.inventory[i].price +
            "," +
            this.spenum +
            "%" +
            "," +
            this.count(a, this.spenum) +
            "," +
            this.content.inventory[i].order +
            "~~";
        } else {
          b += Number(this.content.inventory[i].price);
          c +=
            this.fsortname +
            "," +
            this.s +
            "," +
            this.content.inventory[i].order +
            "," +
            this.num +
            "," +
            this.content.inventory[i].price +
            "," +
            this.accnum +
            "%" +
            "," +
            this.count(this.content.inventory[i].price, this.spenum) +
            "," +
            this.content.inventory[i].orderNum +
            "~~";
        }
      }
      let ap = this.count(a, this.spenum);
      let bp = this.count(b, this.accnum);
      let all = Number(ap) + Number(bp);
      let dis = [(all / Number(this.sumprice)).toFixed(2)] * 100 + "%";
      let allname =
        this.fsortname +
        "," +
        this.s +
        "," +
        this.allname +
        "," +
        this.num +
        "," +
        this.sumprice +
        "," +
        dis +
        "," +
        all.toFixed(2) +
        "," +
        this.content.propOrder;
      this.textdata = allname + "^^" + c;

      // console.log(this.textdata);
    },

    /* 折扣计算 */
    count(m, n) {
      
      return ((m * n) / 100).toFixed(2);

    },

    /* 清空文本域 */
    copydel() {
      this.textdata = "";
    },

    delnum() {
      this.num = 1;
    },
  },
};
</script>

<style scoped lang="less">
.allprice {
  height: auto;
  .p-name {
    height: auto;
    font-size: 1rem;
    font-weight: 600;
    color: #ff9900;
  }
  .p-container {
    height: 110px;
    margin-top: 2px;
    margin-bottom: 5px;
    display: flex;
    // border: 1px solid #999;
    .c-img {
      width: 110px;
      height: 110px;
      border: 1px solid #ece8e8;
    }
    .c-info {
      -webkit-box-flex: 1;
      flex: 1;
      margin-left: 8px;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      flex-direction: column;
      -webkit-box-pack: justify;
      justify-content: space-between;
      .top {
        // margin-bottom: 3px;
        .t-el:nth-of-type(1) {
          font-size: 12px;
          color: #333;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          .t-label {
            color: #999;
          }
        }
        .t-el:last-child {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          // margin-top: 3px;
          .price {
            color: #e60012;
            font-size: 1.5rem;
            .price-unit {
              font-size: 0.75rem;
            }
          }
          .version {
            margin-left: 0.375rem;
            color: #999;
            font-size: 12px;
          }
        }
      }
      .bottom {
        height: 100%;
        .dis {
          display: flex;
          .center {
            height: 1.875rem;
            span {
              font-size: 12px;
            }
            .disnum::before {
              content: "%";
              position: absolute;
              top: 0;
              right: 1.875rem;
              font-size: 0.75rem;
              z-index: 2;
              color: #ff9900;
              line-height: 1.875rem;
            }
            .disnum {
              width: 90px;
              /deep/.el-input-number__decrease {
                height: 14px !important;
                border: none !important;
                border-radius: 0 !important;
                background-repeat: no-repeat;
                background-size: 100% 100%;
                background-position: 50%;
                background-color: rgba(0, 0, 0, 0);
                .el-icon-arrow-down::before {
                  content: "";
                }
                .el-icon-arrow-down {
                  transform: unset !important;
                  font-size: 14px;
                }
              }
              /deep/.el-input-number__decrease:hover {
                color: #ff9900;
              }
              /deep/.el-input-number__increase {
                height: 14px !important;
                border: none !important;
                border-radius: 0 !important;
                background-repeat: no-repeat;
                background-size: 100% 100%;
                background-position: 50%;
                background-color: rgba(0, 0, 0, 0);
                .el-icon-arrow-up::before {
                  content: "";
                }
                .el-icon-arrow-up {
                  transform: unset !important;
                  font-size: 14px;
                }
                .el-icon-arrow-up:hover {
                  color: #ff9900;
                }
              }
              /deep/.el-input-number__increase:hover {
                color: #ff9900;
              }
              /deep/.el-input__inner {
                line-height: 28px;
                height: 30px;
                border-radius: 0;
                padding-left: 6px !important;
                padding-right: 46px !important;
                border: none;
                color: #ff9900;
              }
            }
          }
          .center:last-child {
            margin-left: 10px;
          }
        }
        .copy {
          display: flex;
          button {
            width: 70px;
            height: 35px;
            border: none;
            outline: none;
            background-color: #ff9900;
            color: #fff;
            border-radius: 0.25rem;
            cursor: pointer;
          }
          button:active {
            background-color: #ff9900bb;
          }
          /deep/.el-input-number {
            width: 80px;
            height: 35px;
            margin-left: 2px;
            .el-input-number__decrease {
              height: 17px;
              .el-icon-arrow-down::before {
                line-height: 17px;
                color: #ff9900;
              }
            }
            .el-input-number__increase {
              height: 16px;
              .el-icon-arrow-up::before {
                line-height: 16px;
                color: #ff9900;
              }
            }
            .el-input-number__decrease:hover {
              & + .el-input-number__increase {
                & + .el-input {
                  .el-input__inner {
                    border-color: #ff9900 !important;
                  }
                }
              }
            }

            .el-input-number__increase:hover {
              & + .el-input {
                .el-input__inner {
                  border-color: #ff9900 !important;
                }
              }
            }

            .el-input--mini {
              height: 35px;
              .el-input__inner {
                height: 35px;
                padding-left: 1px;
                padding-right: 30px;
              }
              .el-input__inner:focus {
                border-color: #ff9900 !important;
              }
            }
          }
          .c-none {
            //  display: flex;
            display: none;
          }
        }
      }
    }
  }
}
</style>
